module.exports = new __parcel__URL__("sollip-company.c4e68d8a.png").toString();